import { render, staticRenderFns } from "./IoTDataSimulator.component.vue?vue&type=template&id=94778ee2"
import script from "./IoTDataSimulator.component.ts?vue&type=script&lang=js&external"
export * from "./IoTDataSimulator.component.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports